import * as tslib_1 from "tslib";
import { Field } from './field';
var FieldType = (function (_super) {
    tslib_1.__extends(FieldType, _super);
    function FieldType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FieldType.prototype.ngOnInit = function () {
        this.lifeCycleHooks(this.lifecycle.onInit);
    };
    FieldType.prototype.ngOnChanges = function (changes) {
        this.lifeCycleHooks(this.lifecycle.onChanges);
    };
    FieldType.prototype.ngDoCheck = function () {
        this.lifeCycleHooks(this.lifecycle.doCheck);
    };
    FieldType.prototype.ngAfterContentInit = function () {
        this.lifeCycleHooks(this.lifecycle.afterContentInit);
    };
    FieldType.prototype.ngAfterContentChecked = function () {
        this.lifeCycleHooks(this.lifecycle.afterContentChecked);
    };
    FieldType.prototype.ngAfterViewInit = function () {
        this.lifeCycleHooks(this.lifecycle.afterViewInit);
    };
    FieldType.prototype.ngAfterViewChecked = function () {
        this.lifeCycleHooks(this.lifecycle.afterViewChecked);
    };
    FieldType.prototype.ngOnDestroy = function () {
        this.lifeCycleHooks(this.lifecycle.onDestroy);
    };
    Object.defineProperty(FieldType.prototype, "lifecycle", {
        get: function () {
            return this.field.lifecycle || {};
        },
        enumerable: true,
        configurable: true
    });
    FieldType.prototype.lifeCycleHooks = function (callback) {
        if (callback) {
            callback.bind(this)(this.form, this.field, this.model, this.options);
        }
    };
    return FieldType;
}(Field));
export { FieldType };
//# sourceMappingURL=field.type.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/core/src/templates/field.type.js
// module id = 327
// module chunks = 3